/* global appData */
import {mapState} from 'vuex';

// Scss
import './inline-youtube-video.scss';

// Template and media files
import template from './inline-youtube-video.vhtml';

export default {
    template: template,
    components: {},
    props: {
        videoId: {
            type: String,
            default: '',
        },
        videoLength: {
            type: String,
            default: '',
        },
        videoTitle: {
            type: String,
            default: ''
        },
        thumbnail: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        playerVars: {
            autoplay: 0,
            rel: 0,
            showinfo: 0,
        },
        player: null,
        show: false,
        showClose: false
    }),
    computed: {
        hasId: vm => vm.videoId.length > 0
    },
    methods: {

        ready(e) {
            this.player = e.target;
            this.player.playVideo();
        },

        buffering() {
            clearTimeout(this.$options.delayAnimation);
        },

        ended() {
            this.show = false;
        },

        close(){
            this.show = false;
        }
    }
};



// WEBPACK FOOTER //
// ./assets/_js/components/inline-youtube-video/inline-youtube-video.js